import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { cloneDeep, map } from 'lodash-es';
import { TYPE_JELLYBEANS } from 'site-modules/shared/constants/upper-funnel/type-rankings';
import { getIcon } from 'site-modules/shared/utils/upper-funnel/get-svg-icon';
import { Link } from 'site-modules/shared/components/link/link';
import { TypeIconSymbolSheet } from 'site-modules/shared/components/upper-funnel/type-icon-symbol-sheet/type-icon-symbol-sheet';

export function TypeJellybeanNavV2({
  type = null,
  className = '',
  headingClassName = 'heading-4',
  includeSymbolSheet = false,
}) {
  const jellybeans = cloneDeep(TYPE_JELLYBEANS);
  if (jellybeans[type]) {
    jellybeans[type].linkProps = { rel: 'nofollow' };
  }

  return (
    <Fragment>
      {includeSymbolSheet && <TypeIconSymbolSheet />}
      <div className={classnames('type-jellybean-nav-v2', className)}>
        <h2 className={classnames('mb-1_5 mx-lg-0_75 text-cool-gray-10', headingClassName)}>Browse other types</h2>
        <ul
          className="list-unstyled pe-xl-1"
          style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(145px, 1fr))' }}
        >
          {map(jellybeans, ({ url, name, alt, linkProps }) => (
            <li className="mb-1_5" key={name}>
              <Link
                to={url}
                className="d-flex flex-column align-items-center text-cool-gray-10 fw-medium"
                {...linkProps}
                aria-label={alt}
              >
                <figure className="mb-0" style={{ transform: 'scale(1.7)' }}>
                  {getIcon(name.toLowerCase())}
                </figure>
                {name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </Fragment>
  );
}

TypeJellybeanNavV2.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
  headingClassName: PropTypes.string,
  includeSymbolSheet: PropTypes.bool,
};
